import { FC } from 'react';
import { IconProps, IconColor } from '../types';

export const PlusIcon: FC<IconProps> = ({
  width = 10,
  height = 9,
  fillColor = IconColor.WHITE,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 10 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.10375 0.299999V3.36H9.08375V5.38H6.10375V8.44H3.90375V5.38H0.94375V3.36H3.90375V0.299999H6.10375Z"
        fill={fillColor}
      />
    </svg>
  );
};
